type Size = 'sm' | 'md' | 'lg';
type Variant = 'inline' | 'badge';

export interface BuiltByFluidProps {
  size?: Size;
  variant?: Variant;
}

const sizeClass: Record<Size, string> = {
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

const labelClass: Record<Size, string> = {
  sm: 'text-[11px]',
  md: 'text-xs',
  lg: 'text-sm',
};

export default function BuiltByFluid({
  size = 'md',
  variant = 'inline',
}: BuiltByFluidProps) {
  const wrapperClass =
    variant === 'badge'
      ? 'rounded-full border border-ink-700 bg-ink-900/60 px-2.5 py-1 text-ink-200'
      : 'text-ink-300';
  return (
    <a
      href="https://fluid.io"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 transition-opacity hover:opacity-80 ${wrapperClass}`}
    >
      <span className={labelClass[size]}>Built by</span>
      <img
        src="/fluid-logo.svg"
        alt="Fluid"
        className={`${sizeClass[size]} inline-block align-[-2px]`}
      />
      <span className={`${labelClass[size]} font-semibold tracking-tight text-ink-50`}>
        Fluid
      </span>
    </a>
  );
}
